import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private http = inject(HttpClient);

  public clientVersion = computed(() => this._clientVersion());
  public hasNewVersion = computed(() => {
    const clientVersion = this._clientVersion();
    const serverVersion = this._serverVersion();

    return !!clientVersion && !!serverVersion && clientVersion !== serverVersion;
  });

  private _clientVersion = signal<string | undefined>(undefined);
  private _serverVersion = signal<string | undefined>(undefined);

  public constructor() {
    this.initAppVersion();
  }

  private async initAppVersion() {
    const version = await this.getVersionNumber();

    this._clientVersion.set(version);
    this._serverVersion.set(version);

    setInterval(async () => {
      const newVersion = await this.getVersionNumber();
      this._serverVersion.set(newVersion);
    }, 300000); // 5 minutes
  }

  private getVersionNumber() {
    return firstValueFrom(this.http.get('version.txt', { responseType: 'text' }));
  }
}
